/* GEL BLASTERS INDIA — custom homepage behaviour */
(function () {
  'use strict';

  /* gbi-custom.js is <script src>-included by multiple sections (header,
     hero, recommendations, cart, ...) that can all be present on the same
     page (e.g. header + cart on /cart). Each <script src> tag executes
     independently even though they share a URL, so without this guard
     init() would run more than once and double up every event listener
     (qty +/- buttons, checkout intercept, etc). */
  if (window.__gbiCustomInit) return;
  window.__gbiCustomInit = true;

    function safeRun(label, fn) {
    try {
      fn();
    } catch (err) {
      if (window.console && console.error) console.error('[gbi]', label, err);
    }
  }

  function init() {
    safeRun('scroll reveals', function () {
      var revealEls = document.querySelectorAll('.gbi-reveal');
      if ('IntersectionObserver' in window && revealEls.length) {
        var onReveal = function (entries, obs) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('gbi-in');
              obs.unobserve(e.target);
            }
          });
        };
        var io = new IntersectionObserver(onReveal, { threshold: 0.12 });
        /* very tall elements (e.g. a product column with a long description)
           can never show 12% of themselves on screen, so they would stay
           hidden forever - watch those with threshold 0 instead */
        var ioTall = new IntersectionObserver(onReveal, { threshold: 0 });
        revealEls.forEach(function (el) {
          var tall = el.offsetHeight * 0.12 > window.innerHeight * 0.8;
          (tall ? ioTall : io).observe(el);
        });
      } else {
        revealEls.forEach(function (el) { el.classList.add('gbi-in'); });
      }
    });

    safeRun('FAQ accordion', function () {
      document.querySelectorAll('.gbi-faq__item').forEach(function (item) {
        var btn = item.querySelector('.gbi-faq__q');
        var panel = item.querySelector('.gbi-faq__a');
        if (!btn || !panel) return;
        btn.addEventListener('click', function () {
          var open = item.classList.toggle('gbi-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
        });
      });
    });

    safeRun('video cards', function () {
      var vcards = document.querySelectorAll('.gbi-vcard');
      if (vcards.length) {
        var visibility = new Map();

        function playOnly(card) {
          vcards.forEach(function (other) {
            var ov = other.querySelector('video');
            if (!ov) return;
            if (other === card) {
              if (ov.paused) { ov.muted = true; ov.play().catch(function () {}); }
              other.classList.add('gbi-playing');
            } else {
              if (!ov.paused) ov.pause();
              other.classList.remove('gbi-playing');
            }
          });
        }

        function pickMostVisible() {
          var best = null, bestRatio = 0;
          visibility.forEach(function (ratio, card) {
            if (ratio > bestRatio) { bestRatio = ratio; best = card; }
          });
          if (best && bestRatio > 0.55) playOnly(best);
          else vcards.forEach(function (c) {
            var v = c.querySelector('video');
            if (v && !v.paused) { v.pause(); c.classList.remove('gbi-playing'); }
          });
        }

        if ('IntersectionObserver' in window) {
          var vio = new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { visibility.set(e.target, e.intersectionRatio); });
            pickMostVisible();
          }, { threshold: [0, 0.25, 0.55, 0.75, 1] });
          vcards.forEach(function (c) { vio.observe(c); });

          var rail = vcards[0].closest('.gbi-vrail');
          if (rail) {
            var scrollTimer;
            rail.addEventListener('scroll', function () {
              clearTimeout(scrollTimer);
              scrollTimer = setTimeout(pickMostVisible, 120);
            }, { passive: true });
          }
        } else {
          var first = vcards[0].querySelector('video');
          if (first) { first.muted = true; first.play().catch(function () {}); }
        }

        vcards.forEach(function (card) {
          var video = card.querySelector('video');
          if (!video) return;
          card.addEventListener('click', function (ev) {
            if (ev.target.closest('.gbi-vcard__product')) return;
            video.muted = !video.muted;
            card.classList.toggle('gbi-muted', video.muted);
          });
        });
      }
    });

    safeRun('video poster alt', function () {
      /* Shopify's video_tag filter always renders an inner <img> fallback
         with no alt attribute, and there's no Liquid param to set one —
         patch it here instead so Lighthouse/screen readers see real text. */
      document.querySelectorAll('.gbi-vcard').forEach(function (card) {
        var video = card.querySelector('video');
        var fallbackImg = video ? video.querySelector('img') : null;
        if (!fallbackImg || fallbackImg.getAttribute('alt')) return;
        var thumb = card.querySelector('.gbi-vcard__thumb');
        var pname = card.querySelector('.gbi-vcard__pname');
        fallbackImg.alt = (thumb && thumb.alt) || (pname && pname.textContent.trim()) || 'Product video';
      });
    });

    safeRun('hero particles', function () {
      document.querySelectorAll('[data-gbi-particles]').forEach(function (canvas) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var host = canvas.parentElement;
        var ctx = canvas.getContext('2d');
        var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
        var W, H, parts = [], running = false, raf;
        var COLORS = ['255,186,102', '255,186,102', '247,44,59', '61,123,255'];

        function size() {
          W = host.offsetWidth; H = host.offsetHeight;
          canvas.width = W * dpr; canvas.height = H * dpr;
          canvas.style.width = W + 'px'; canvas.style.height = H + 'px';
          ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        }
        function make() {
          var n = Math.max(14, Math.min(30, Math.round(W / 42)));
          parts = [];
          for (var i = 0; i < n; i++) {
            parts.push({
              x: Math.random() * W,
              y: Math.random() * H,
              r: 0.8 + Math.random() * 1.8,
              s: 0.1 + Math.random() * 0.28,
              a: 0.1 + Math.random() * 0.3,
              ph: Math.random() * 6.28,
              sw: 8 + Math.random() * 18,
              c: COLORS[(Math.random() * COLORS.length) | 0]
            });
          }
        }
        function tick() {
          if (!running) return;
          ctx.clearRect(0, 0, W, H);
          for (var i = 0; i < parts.length; i++) {
            var p = parts[i];
            p.y -= p.s;
            p.ph += 0.008;
            if (p.y < -6) { p.y = H + 6; p.x = Math.random() * W; }
            ctx.beginPath();
            ctx.arc(p.x + Math.sin(p.ph) * p.sw, p.y, p.r, 0, 6.2832);
            ctx.fillStyle = 'rgba(' + p.c + ',' + p.a + ')';
            ctx.fill();
          }
          raf = requestAnimationFrame(tick);
        }
        function start() { if (!running) { running = true; tick(); } }
        function stop() { running = false; if (raf) cancelAnimationFrame(raf); }

        size(); make();
        var rt;
        window.addEventListener('resize', function () {
          clearTimeout(rt);
          rt = setTimeout(function () { size(); make(); }, 180);
        }, { passive: true });

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
          }, { threshold: 0 }).observe(host);
        } else {
          start();
        }
      });
    });

    safeRun('compare module', function () {
      document.querySelectorAll('[data-gbi-compare]').forEach(function (root) {
        var dataEl = root.querySelector('script[type="application/json"]');
        if (!dataEl) return;
        var products;
        try { products = JSON.parse(dataEl.textContent); } catch (err) { return; }
        if (!products || !products.length) return;

        var selects = root.querySelectorAll('.gbi-select');
        var panels = root.querySelectorAll('.gbi-cmp-panel');
        var emptyLabel = root.getAttribute('data-empty-label') || 'Select a model';
        var labelRe = /^(key\s*features|features|included in the box)$/i;

        function isHeadingEl(el) {
          if (/^H[1-6]$/.test(el.tagName)) return true;
          if (el.tagName !== 'P') return false;
          var t = el.textContent.trim();
          if (!t || t.length > 45) return false;
          if (/^[•\-*]|^\d+\s*[x×]\b/i.test(t)) return false;
          return true;
        }

        function extractKeySections(html) {
          if (!html) return '';
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          var out = [];
          var current = null;
          Array.prototype.forEach.call(wrap.children, function (el) {
            if (isHeadingEl(el)) {
              var text = el.textContent.trim().replace(/:$/, '');
              if (labelRe.test(text)) {
                current = document.createElement('div');
                current.className = 'gbi-cmp-section';
                var h = document.createElement('h4');
                h.textContent = text;
                current.appendChild(h);
                out.push(current);
              } else {
                current = null;
              }
            } else if (current) {
              current.appendChild(el.cloneNode(true));
            }
          });
          if (!out.length) return '';
          var holder = document.createElement('div');
          out.forEach(function (s) { holder.appendChild(s); });
          return holder.innerHTML;
        }

        selects.forEach(function (sel) {
          var ph = document.createElement('option');
          ph.value = '';
          ph.textContent = sel.getAttribute('data-placeholder') || 'CHOOSE MODEL';
          sel.appendChild(ph);
          products.forEach(function (p, i) {
            var opt = document.createElement('option');
            opt.value = String(i);
            opt.textContent = p.title;
            sel.appendChild(opt);
          });
        });

        function escapeHtml(str) {
          var div = document.createElement('div');
          div.textContent = str == null ? '' : String(str);
          return div.innerHTML;
        }

        function render(panel, p) {
          if (!p) {
            panel.innerHTML = '<div class="gbi-cmp-panel__empty">' + emptyLabel + '</div>';
            return;
          }
          var soldOut = p.avail ? '' : ' <span class="gbi-chip gbi-chip--dim">Out of stock</span>';
          var safeTitle = escapeHtml(p.title);
          var body = extractKeySections(p.descHtml) || ('<p>' + escapeHtml(p.desc) + '</p>');
          panel.innerHTML =
            '<div class="gbi-cmp-panel__media"><img src="' + p.img + '" alt="' + safeTitle + '" loading="lazy"></div>' +
            '<h3 class="gbi-cmp-panel__name">' + safeTitle + '</h3>' +
            '<div class="gbi-cmp-panel__price">' + p.price + soldOut + '</div>' +
            '<div class="gbi-cmp-panel__desc">' + body + '</div>' +
            '<a class="gbi-btn gbi-btn--ghost" href="' + p.url + '">View model</a>';
        }

        selects.forEach(function (sel, idx) {
          render(panels[idx], null);
          sel.addEventListener('change', function () {
            var p = sel.value === '' ? null : products[parseInt(sel.value, 10)];
            render(panels[idx], p);
          });
        });
      });
    });

    safeRun('product gallery thumbs', function () {
      document.querySelectorAll('[data-gbi-gallery]').forEach(function (g) {
        var main = g.querySelector('[data-gbi-gallery-main] img');
        g.querySelectorAll('[data-gbi-thumb]').forEach(function (t) {
          t.addEventListener('click', function () {
            if (!main) return;
            main.src = t.getAttribute('data-src');
            main.removeAttribute('srcset');
            g.querySelectorAll('[data-gbi-thumb]').forEach(function (o) { o.classList.remove('gbi-active'); });
            t.classList.add('gbi-active');
          });
        });
      });
    });

    safeRun('qty steppers', function () {
      document.querySelectorAll('[data-gbi-qty]').forEach(function (w) {
        var input = w.querySelector('input');
        if (!input) return;
        w.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = parseInt(input.value || '1', 10);
            v += (b.getAttribute('data-dir') === 'up' ? 1 : -1);
            var min = parseInt(input.min || '1', 10);
            if (v < min) v = min;
            input.value = v;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      });
    });

    safeRun('product variant picker', function () {
      document.querySelectorAll('[data-gbi-product]').forEach(function (root) {
        var dataEl = root.querySelector('script[data-gbi-variants]');
        if (!dataEl) return;
        var variants;
        try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
        var sel = root.querySelector('[data-gbi-variant-select]');
        var idInput = root.querySelector('input[name="id"]');
        var priceEl = root.querySelector('[data-gbi-price]');
        var wasEl = root.querySelector('[data-gbi-was]');
        var stockEl = root.querySelector('[data-gbi-stock]');
        var atc = root.querySelector('[data-gbi-atc]');
        var restock = root.querySelector('[data-gbi-restock]');
        var lowText = root.getAttribute('data-low-text') || 'Only a few left';
        var lowMax = parseInt(root.getAttribute('data-low-max') || '10', 10);
        var soldTxt = root.getAttribute('data-soldout-text') || 'Sold out';
        var atcTxt = atc ? atc.textContent : '';

        function apply(v) {
          if (!v) return;
          if (idInput) idInput.value = v.id;
          if (priceEl) priceEl.textContent = v.price;
          if (wasEl) {
            if (v.was) { wasEl.textContent = v.was; wasEl.style.display = ''; }
            else { wasEl.style.display = 'none'; }
          }
          if (stockEl) {
            if (!v.available) {
              stockEl.className = 'gbi-stockchip gbi-stockchip--out';
              stockEl.textContent = soldTxt;
            } else if (v.qty !== null && v.qty > 0 && v.qty <= lowMax) {
              stockEl.className = 'gbi-stockchip gbi-stockchip--low';
              stockEl.innerHTML = '<span class="gbi-dot"></span>' + lowText.replace('[qty]', v.qty);
            } else {
              stockEl.className = 'gbi-stockchip';
              stockEl.innerHTML = '<span class="gbi-dot gbi-dot--ok"></span>In stock';
            }
          }
          if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? atcTxt : soldTxt; }
          if (restock) restock.style.display = v.available ? 'none' : '';
        }

        if (sel) {
          sel.addEventListener('change', function () { apply(variants[parseInt(sel.value, 10)]); });
          apply(variants[parseInt(sel.value || '0', 10)]);
        } else {
          apply(variants[0]);
        }
      });
    });
        safeRun('delivery estimator', function () {
      document.querySelectorAll('[data-gbi-delivery]').forEach(function (root) {
        var toggle = root.querySelector('[data-gbi-delivery-toggle]');
        var panel = root.querySelector('[data-gbi-delivery-panel]');
        var select = root.querySelector('[data-gbi-delivery-select]');
        var result = root.querySelector('[data-gbi-delivery-result]');
        var etaEl = root.querySelector('[data-gbi-delivery-days]');
        var stateEl = root.querySelector('[data-gbi-delivery-state-name]');
        if (!toggle || !panel || !select) return;

        toggle.addEventListener('click', function () {
          var open = root.classList.toggle('gbi-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
        });

        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          var days = opt ? opt.getAttribute('data-days') : '';
          if (!days) {
            if (result) { result.classList.remove('gbi-in'); result.hidden = true; }
          } else {
            if (etaEl) etaEl.textContent = days;
            if (stateEl) stateEl.textContent = opt.textContent;
            if (result) {
              result.hidden = false;
              result.classList.remove('gbi-in');
              void result.offsetWidth;
              requestAnimationFrame(function () { result.classList.add('gbi-in'); });
            }
          }
          if (root.classList.contains('gbi-open')) {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        });
      });
    });


    safeRun('product recommendations', function () {
      document.querySelectorAll('[data-gbi-recs]').forEach(function (el) {
        var url = el.getAttribute('data-url');
        if (!url) return;
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('[data-gbi-recs-content]');
          var target = el.querySelector('[data-gbi-recs-content]');
          if (inner && target && inner.innerHTML.trim().length > 0) {
            target.innerHTML = inner.innerHTML;
          } else {
            var sec = el.closest('.gbi-sec') || el;
            sec.style.display = 'none';
          }
        }).catch(function () {});
      });
    });

    safeRun('article share', function () {
      document.querySelectorAll('[data-gbi-share-copy]').forEach(function (btn) {
        var label = btn.querySelector('span');
        var original = label ? label.textContent : '';
        var resetTimer;
        btn.addEventListener('click', function () {
          var url = btn.getAttribute('data-share-url') || window.location.href;
          var done = function () {
            clearTimeout(resetTimer);
            btn.classList.add('gbi-copied');
            if (label) label.textContent = 'Copied!';
            resetTimer = setTimeout(function () {
              btn.classList.remove('gbi-copied');
              if (label) label.textContent = original;
            }, 1800);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(done).catch(function () {});
          } else {
            var ta = document.createElement('textarea');
            ta.value = url;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            try { document.execCommand('copy'); done(); } catch (e) {}
            document.body.removeChild(ta);
          }
        });
      });
    });



    safeRun('cart page', function () {
      initCart();
    });

    safeRun('header drawer', function () {
      var drawer = document.querySelector('[data-gbi-drawer]');
      if (drawer) {
        document.querySelectorAll('[data-gbi-menu-toggle]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            drawer.classList.add('gbi-open');
            document.body.classList.add('gbi-lock');
          });
        });
        drawer.querySelectorAll('[data-gbi-drawer-close]').forEach(function (el) {
          el.addEventListener('click', function () {
            drawer.classList.remove('gbi-open');
            document.body.classList.remove('gbi-lock');
          });
        });
      }
    });
    safeRun('policy toc', function () {
      var body = document.querySelector('.shopify-policy__body');
      if (!body) return;

      var headings = body.querySelectorAll('h2, h3');
      if (!headings.length) return;

      var layout = document.createElement('div');
      layout.className = 'gbi-policy__layout';

      var toc = document.createElement('aside');
      toc.className = 'gbi-policy__toc';
      toc.hidden = true;
      toc.innerHTML = '<div class="gbi-policy__toc-label">On this page</div><nav class="gbi-policy__toc-list"></nav>';
      var list = toc.querySelector('.gbi-policy__toc-list');

      headings.forEach(function (h, i) {
        if (!h.id) h.id = 'gbi-sec-' + (i + 1);
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        if (h.tagName === 'H3') a.style.paddingLeft = '20px';
        list.appendChild(a);
      });

      body.parentNode.insertBefore(layout, body);
      layout.appendChild(toc);
      layout.appendChild(body);
      toc.hidden = false;

      var links = list.querySelectorAll('a');
      if (!('IntersectionObserver' in window) || !links.length) return;

      var map = {};
      links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var link = map[entry.target.id];
          if (!link) return;
          if (entry.isIntersecting) {
            links.forEach(function (a) { a.classList.remove('is-active'); });
            link.classList.add('is-active');
          }
        });
      }, { rootMargin: '-100px 0px -70% 0px' });

      headings.forEach(function (h) { observer.observe(h); });
    });
  }


  /* ============================================================
     CART PAGE — live totals via Shopify Cart AJAX API
     (/cart/change.js, /cart/add.js, /cart.js) instead of full
     page reloads, so the free-shipping bar / subtotal / COD
     notice update instantly. Also intercepts the Checkout button
     to show a cross-sell popup (gel balls etc.) before handing
     off to /checkout.
     ============================================================ */
  function initCart() {
    var cartForm = document.querySelector('[data-gbi-cart-form]');
    var shipbar = document.querySelector('[data-gbi-shipbar]');
    var subtotalEl = document.querySelector('[data-gbi-subtotal]');
    var codwarn = document.querySelector('[data-gbi-codwarn]');
    var cartCountEls = document.querySelectorAll('[data-gbi-cart-count]');
    if (!cartForm && !document.querySelector('[data-gbi-checkout-form]')) return;

    var moneyFormat = (shipbar && shipbar.getAttribute('data-money-format')) || '₹{{amount}}';

    function formatMoney(cents) {
      if (isNaN(cents) || cents === null) return '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var match = moneyFormat.match(placeholderRegex);
      var kind = match ? match[1] : 'amount';

      function withDelimiters(number, precision, thousands, decimal) {
        precision = (precision === undefined) ? 2 : precision;
        thousands = thousands || ',';
        decimal = decimal || '.';
        number = (number / 100).toFixed(precision);
        var parts = number.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var frac = parts[1] ? decimal + parts[1] : '';
        return whole + frac;
      }

      var value;
      switch (kind) {
        case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
        default: value = withDelimiters(cents, 2);
      }
      return match ? moneyFormat.replace(placeholderRegex, value) : ('₹' + value);
    }

    function renderShipbar(totalCents) {
      if (!shipbar) return;
      var min = parseInt(shipbar.getAttribute('data-threshold-cents') || '0', 10);
      var label = shipbar.querySelector('[data-gbi-shipbar-label]');
      var fill = shipbar.querySelector('[data-gbi-shipbar-fill]');
      if (min > 0 && totalCents >= min) {
        if (label) {
          label.textContent = shipbar.getAttribute('data-unlocked-text') || 'Free delivery unlocked';
          label.classList.add('gbi-unlocked');
        }
        if (fill) { fill.style.width = '100%'; fill.classList.add('gbi-unlocked'); }
      } else if (min > 0) {
        var remaining = min - totalCents;
        var pct = Math.max(0, Math.min(100, Math.floor((totalCents * 100) / min)));
        if (label) {
          label.classList.remove('gbi-unlocked');
          label.innerHTML = (shipbar.getAttribute('data-prefix') || 'Add') + ' <b>' + formatMoney(remaining) + '</b> ' + (shipbar.getAttribute('data-suffix') || 'more to unlock free delivery');
        }
        if (fill) { fill.style.width = pct + '%'; fill.classList.remove('gbi-unlocked'); }
      }
    }

    function renderCodWarning(totalCents) {
      if (!codwarn) return;
      var enabled = codwarn.getAttribute('data-enabled') === 'true';
      var max = parseInt(codwarn.getAttribute('data-cod-max-cents') || '0', 10);
      codwarn.style.display = (enabled && max > 0 && totalCents > max) ? '' : 'none';
    }

    function renderSubtotal(totalCents) {
      if (subtotalEl) subtotalEl.textContent = formatMoney(totalCents);
    }

    function applyCartState(cart) {
      renderShipbar(cart.total_price);
      renderCodWarning(cart.total_price);
      renderSubtotal(cart.total_price);
      cartCountEls.forEach(function (el) { el.textContent = cart.item_count; });
    }

    function changeLine(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart change failed');
        return r.json();
      });
    }

    /* per-row qty + remove handlers (falls back to native form submit if AJAX fails) */
    if (cartForm) {
      cartForm.querySelectorAll('[data-gbi-citem]').forEach(function (row) {
        var key = row.getAttribute('data-key');
        var input = row.querySelector('[data-gbi-qty] input');
        var lineTotalEl = row.querySelector('[data-gbi-line-total]');
        var removeBtn = row.querySelector('[data-gbi-remove]');
        var t;

        if (input) {
          input.addEventListener('change', function () {
            clearTimeout(t);
            t = setTimeout(function () {
              var qty = Math.max(0, parseInt(input.value || '0', 10));
              changeLine(key, qty).then(function (cart) {
                var line = cart.items.filter(function (i) { return i.key === key; })[0];
                if (!line) {
                  row.remove();
                  if (cart.item_count === 0) { window.location.reload(); return; }
                } else if (lineTotalEl) {
                  lineTotalEl.textContent = formatMoney(line.line_price);
                }
                applyCartState(cart);
              }).catch(function () { cartForm.submit(); });
            }, 350);
          });
        }

        if (removeBtn) {
          removeBtn.addEventListener('click', function (ev) {
            ev.preventDefault();
            changeLine(key, 0).then(function (cart) {
              row.remove();
              if (cart.item_count === 0) { window.location.reload(); return; }
              applyCartState(cart);
            }).catch(function () { window.location.href = removeBtn.getAttribute('href'); });
          });
        }
      });
    }

    /* ---- checkout button: cross-sell popup before handoff to /checkout ---- */
    var checkoutForm = document.querySelector('[data-gbi-checkout-form]');
    var modal = document.querySelector('[data-gbi-xmodal]');
    var catalogEl = document.querySelector('[data-gbi-xsell-catalog]');
    var catalog = [];
    if (catalogEl) {
      try { catalog = JSON.parse(catalogEl.textContent) || []; } catch (e) { catalog = []; }
    }

    function closeModal() {
      if (!modal) return;
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('gbi-lock');
    }

    function openModal(items, checkoutUrl) {
      if (!modal) { window.location.href = checkoutUrl; return; }
      var grid = modal.querySelector('[data-gbi-xmodal-grid]');
      var titleEl = modal.querySelector('[data-gbi-xmodal-title]');
      var subEl = modal.querySelector('[data-gbi-xmodal-sub]');
      var continueBtn = modal.querySelector('[data-gbi-xmodal-continue]');

      if (titleEl) titleEl.textContent = modal.getAttribute('data-title') || "Don't forget ammo";
      if (subEl) subEl.textContent = modal.getAttribute('data-sub') || '';
      grid.innerHTML = '';

      items.forEach(function (p) {
        var card = document.createElement('div');
        card.className = 'gbi-xmodal__card';
        card.innerHTML =
          '<img src="' + p.image + '" alt="" loading="lazy">' +
          '<div class="gbi-xmodal__cname"></div>' +
          '<div class="gbi-xmodal__cprice"></div>' +
          '<button type="button" class="gbi-btn gbi-btn--solid"></button>';
        card.querySelector('.gbi-xmodal__cname').textContent = p.title;
        card.querySelector('.gbi-xmodal__cprice').textContent = p.price;
        card.querySelector('img').alt = p.title;
        var btn = card.querySelector('button');
        btn.textContent = modal.getAttribute('data-btn-label') || 'Add';
        btn.addEventListener('click', function () {
          btn.disabled = true;
          btn.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: p.variantId, quantity: 1 })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          }).then(function () {
            btn.textContent = 'Added ✓';
            card.classList.add('gbi-xmodal__card--added');
            return fetch('/cart.js').then(function (r) { return r.json(); });
          }).then(function (cart) { applyCartState(cart); })
            .catch(function () {
              btn.disabled = false;
              btn.textContent = modal.getAttribute('data-btn-label') || 'Add';
            });
        });
        grid.appendChild(card);
      });

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('gbi-lock');

      if (continueBtn) continueBtn.onclick = function () { window.location.href = checkoutUrl; };
      modal.querySelectorAll('[data-gbi-xmodal-close]').forEach(function (el) { el.onclick = closeModal; });
    }

   

    if (modal) {
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) closeModal();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
